import { Action, createReducer, on } from "@ngrx/store";
import { IPuntoPosteManagementState } from "./punto-poste-management";
import { ANAGRAFICA_SUCCESS, CAMBIO_PASSWORD_SUCCESS, GET_BOARD_LIST_SUCCESS, ORARI_CHIUSURE_PUT_SUCCESS, ORARI_CHIUSURE_SUCCESS } from "./punto-poste-management.actions";
import { IResponseAnagrafica } from "../../interfaces/anagrafica";
import { IResponseCambioPassword } from "../../interfaces/cambio-password";
import { IResponseOrariChiusure } from "../../interfaces/orari-chiusure";
import { IResponseBacheca } from "../../interfaces/bacheca";

/* INITIAL STATE */
const initialState: IPuntoPosteManagementState = {
  responseAnagrafica: null,
  responseCambioPassword: null,
  responseOrariChiusure: null,
  responseOrariChiusurePut: null,
  responseBacheca: null
};

const handleResponseAnagrafica = (
  state: IPuntoPosteManagementState,
  { responseAnagrafica }: { responseAnagrafica: IResponseAnagrafica | null }
): IPuntoPosteManagementState => {
  return {
    ...state,
    responseAnagrafica,
  };
};

const handleResponseCambioPassword = (
  state: IPuntoPosteManagementState,
  { responseCambioPassword }: { responseCambioPassword: IResponseCambioPassword | null }
): IPuntoPosteManagementState => {
  return {
    ...state,
    responseCambioPassword,
  };
};

const handleResponseOrariChiusure = (
  state: IPuntoPosteManagementState,
  { responseOrariChiusure }: { responseOrariChiusure: IResponseOrariChiusure | null }
): IPuntoPosteManagementState => {
  return {
    ...state,
    responseOrariChiusure,
  };
};

const handleResponsePutOrariChiusure = (
  state: IPuntoPosteManagementState,
  { responseOrariChiusurePut }: { responseOrariChiusurePut: IResponseOrariChiusure | null }
): IPuntoPosteManagementState => {
  return {
    ...state,
    responseOrariChiusurePut,
  };
};

const handleResponseBacheca = (
  state: IPuntoPosteManagementState,
  { responseBacheca }: { responseBacheca: IResponseBacheca | null }
): IPuntoPosteManagementState => {
  return {
    ...state,
    responseBacheca,
  };
};



/* REDUCER */
export const reducer = createReducer(
  initialState,
  on(ANAGRAFICA_SUCCESS, handleResponseAnagrafica),
  on(CAMBIO_PASSWORD_SUCCESS, handleResponseCambioPassword),
  on(ORARI_CHIUSURE_SUCCESS, handleResponseOrariChiusure),
  on(ORARI_CHIUSURE_PUT_SUCCESS, handleResponsePutOrariChiusure),
  on(GET_BOARD_LIST_SUCCESS, handleResponseBacheca),
);

export const puntoPosteManagementReducer = (
  state: IPuntoPosteManagementState | undefined,
  action: Action
): IPuntoPosteManagementState => reducer(state, action);
